<template>
  <div>
    <h3>Historique de désignation</h3>
    <table class="table table-sm">
      <thead>

        <tr>
          <th>Dossier</th>
          <th>Statut</th>
          <th style="min-width: 90px; text-align:center;">Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for='dossier in dossiers' class="row-hover" >
          <router-link class="nav-link" tag="td" v-text="dossier.nom_dossier" :to="{ name: 'dossier', params: { service_provider_id: $route.params.service_provider_id,designation_dossier_id: dossier.dossier_id }}"></router-link>
          <router-link class="nav-link" tag="td" v-text="dossier.status" :to="{ name: 'dossier', params: { service_provider_id: $route.params.service_provider_id,designation_dossier_id: dossier.dossier_id }}"></router-link>
          <router-link class="nav-link date" tag="td" v-text="dossier.effective_at" :to="{ name: 'dossier', params: { service_provider_id: $route.params.service_provider_id,designation_dossier_id: dossier.dossier_id }}"></router-link>
        </tr>
      </tbody>
    </table>
    <router-link class="nav-link" :to="{ name: 'dossiers', params: { service_provider_id: $route.params.service_provider_id }}">Voir les dossiers</router-link>
  </div>
</template>

<script>
export default {
  name: 'SPDossier',
  props: {
    dossiers: {},
  },

}
</script>
<style>
.date {
  text-align:center;
}
</style>
